import { LoanTypeEnum } from '../../../models/enum/loan-type.enum';
import { P2Alert, P2TextDescription } from 'react-bootstrap-common-script';
import { Radio_Loan_Types } from '../../../utils/shared-radio';
import RadioGroup from '../../form/grouped/radio/radio-group';
import { InfoCard } from '../../info';
import { InfoCircle } from '../../../assets/svg';
import { TextInfo } from '../../text';
import { useMemo } from 'react';
import { OwnershipReasonEnum } from '../../../models/enum/ownership-reason.enum';
import { FlatRoomTypeEnum } from '../../../models/enum/flat-room-type.enum';
import { HDBPayableFeeValuation } from '../../../utils/form-helper';
import { HDBLinks } from '../../../utils/shared/links';

interface FinancingFormProps {
  show_new_loan_info?:boolean; //This will be used for STAGE B Reviewing page.
  variant?:"default" | "review";
  current_loan_type?: LoanTypeEnum;
  new_loan_type?: LoanTypeEnum;
  flat_type?: FlatRoomTypeEnum;
  current_loan_date?: string;
  onLoanTypeChange: (value: string) => void;
  has_outgoing_owner?:boolean;
  change_ownership_reason?: OwnershipReasonEnum;
  alertNumber?: number;
  isFlatResale?: boolean;
  forceError?: boolean;
}

function FinancingForm({isFlatResale=false, variant="default",has_outgoing_owner=false, change_ownership_reason=undefined, current_loan_date="", flat_type=undefined,alertNumber=0, ...props }: FinancingFormProps) {
 
  let loan_type_title: string = "";
  switch(props.new_loan_type){
      case LoanTypeEnum.hdb_loan:
          loan_type_title = "HDB Loan";
          break;
      case LoanTypeEnum.bank_loan:
          loan_type_title = "Bank Loan";
          break;
      default: 
          loan_type_title = "No Loan";
          break;
  }
  const isFreshLoan = useMemo(()=>{
    return props.current_loan_type === LoanTypeEnum.no_loan;
  },[ props.current_loan_type ])

  const newLoanDescription = useMemo(()=>{
    return `As part of the process, the current outstanding loan under the current owners' account will have to be closed. Proposed owners may obtain a new loan to finance the outstanding mortgage.${has_outgoing_owner ? ' Proposed owner(s) would need to refund the amount of CPF savings used by the outgoing owner(s).' : ''}`
  },[has_outgoing_owner])


  const hdbLoanPayableValue = useMemo(()=>{
    return HDBPayableFeeValuation(flat_type);
  },[flat_type]);


  // NOTE : if show_new_loan_info is set to true, mean it will only show the info title for the loan type 
  if( props.show_new_loan_info ){
    return (
      <TextInfo title='New Loan Type:' description={<div><p className='m-0'>{loan_type_title}</p></div>} />
    )
  }

  return (
    <div>
      <P2TextDescription color='#000' title='New Loan Information' />
      <div style={{ marginTop: 24 }}>
        <P2TextDescription color='#000' description={newLoanDescription} />
      </div>

      <RadioGroup style={{ marginTop: 24 }} layout='inline' items={Radio_Loan_Types} onItemSelect={props.onLoanTypeChange} value={props.new_loan_type} label={'Type of Loan Required'} required />
      {props.forceError && !props.new_loan_type &&      
        <div style={{ marginTop: 24 }}>
          <P2Alert variant={"danger"} text={"This is a required field."}></P2Alert>
        </div>
      }
      {isFreshLoan && props.new_loan_type === LoanTypeEnum.bank_loan && <div style={{ marginTop: 32 }}>
        <InfoCard style={{ backgroundColor: "#FFF" }} icon={<InfoCircle />} description={"Proposed owners would need to obtain the bank's letter of offer to complete the application."} />
      </div>}

      {props.new_loan_type === LoanTypeEnum.no_loan && <div style={{ marginTop: 32 }}>
        <InfoCard style={{ backgroundColor: "#FFF" }} icon={<InfoCircle />} description={<p>If you require a loan at the later stage of the application process, you will be required to cancel the application and re-submit a new application.</p>} />
      </div>}

      {isFreshLoan && change_ownership_reason === OwnershipReasonEnum.divorce && props.new_loan_type === LoanTypeEnum.hdb_loan && <div style={{ marginTop: 32 }}>
        <InfoCard style={{ backgroundColor: "#FFF" }} icon={<InfoCircle />} description={"HDB does not grant a loan for any cash consideration stated in the divorce documents."} />
      </div>}
      {/* isFreshLoan removed, new logic change to isFlatResale && new_loan = hdb */}
      {isFlatResale && props.new_loan_type === LoanTypeEnum.hdb_loan && <div style={{ marginTop: 32 }}>
        <InfoCard style={{ backgroundColor: "#FFF" }} icon={<InfoCircle />} description={`As the proposed owners require a new HDB loan, they would be required to obtain a current market valuation report to determine the mortgage loan ceiling as the flat was bought from the resale market. Valuation fee applies.`} />
      </div>}

      {alertNumber !== 0 &&      
      <div className='polymer-shared-alert-container'>
          <div style={{ marginTop: 24 }}>
            {alertNumber === 1  && <P2Alert variant={"success"} text={"Based on the information you have provided above, you are eligible to proceed with the application for Change in Flat Ownership, subject to document verification by HDB."}></P2Alert>}
            {(alertNumber === 2 || alertNumber === 3)  && <P2Alert variant={"danger"} text={<div>It appears that you do not have an approved HDB Loan Eligibility (HLE) letter. Please <a href={HDBLinks.apply_hle_url} className="polymer-text-links">apply for an HLE letter</a> first as HLE applications will take 21 working days for processing. You may continue with the application for change in flat ownership and proceed to submit once HLE has been obtained.</div>}></P2Alert>}
          </div>
       </div>}
 

      {/* <div style={{ marginTop: 24 }}>
        <P2TextDescription color='#000' description={<p className='m-0'>If you want to estimate the loan amount needed for changing flat ownership, check out our <a href='#'>Financial Planning Calculator</a>. It's quick, easy, and we're here to help if you need it!</p>} />
      </div> */}


    </div>
  )
}

export default FinancingForm